import React from 'react';
import cs from 'classnames';
import css from '../index.css';
import BrokersCatalog from '../BrokersCatalog';
import {connect} from 'react-redux';
import AnonymousBanner from '~/components/search/AnonymousBanner';
import Spinner from '~/components/common/Spinner';

class CompanySaved extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const userIsLoggedIn = this.props.userIsLoggedIn;
    const userLoading = this.props.userLoading;
    const infoLoading = this.props.infoLoading;
    if (userLoading || infoLoading || this.props.loading) {
      return <div className={cs(css.loadingWrapper)}><Spinner/></div>;
    } else if (!userIsLoggedIn) {
      return <AnonymousBanner/>;
    }
    return (
      <div>
        {this.renderTable()}
        {(!this.props.brokersData || !this.props.brokersData.length)
          ? this.renderContent(this.props.type)
          : <BrokersCatalog type={this.props.type}/>
        }
      </div>
    );
  }
  renderTable() {
    return (
      <div className={cs(css.tatleContent)}>
        <div className={cs(css.dot)}>DOT</div>
        <div className={cs(css.broker)}>Broker</div>
        <div className={cs(css.operation)}>Operation</div>
      </div>
    );
  }
  renderContent(type) {
    if (type === 'save') {
      return (
        <div className={cs(css.notFoundWrapper)}>
          <img src='/assets/saved-empty-state.png' alt=''/>
          <p>No Brokers/Shippers have been saved</p>
          <p>Save your favorite brokers/shippers and only see the loads they post</p>
        </div>
      );
    } else if (type === 'hide') {
      return (
        <div className={cs(css.notFoundWrapper)}>
          <img src='/assets/hidden-empty-state.png' alt=''/>
          <p>No Brokers/Shippers have been blocked</p>
          <p>Block the Brokers/shippers you prefer not to work with</p>
        </div>
      );
    }
  }
}
export default connect(({user, myCompany, account: {userInfo}}, {loading, type}) => ({
  brokersData: myCompany[type] || [],
  userIsLoggedIn: user.isLoggedIn,
  loading: loading,
  type: type,
  userLoading: user.loading,
  infoLoading: userInfo.loading,
}))(CompanySaved);



// WEBPACK FOOTER //
// ./src/components/pages/MyCompany/saved/index.js